import * as React from "react";
const SvgUnderline01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7 4v6a5 5 0 0 0 10 0V4M5 20h14"
}));
export default SvgUnderline01;
//# sourceMappingURL=Underline01.js.map